// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardStats_container__2LRpd"};